<template>
  <section class="category-page" data-t="category-page">
    <ClientOnly>
      <Teleport to="#casino-filters">
        <CategoryFilters
          v-model:provider="providerCode"
          v-model:theme="categoryTheme"
          v-model:favorite="isFavorite"
          :parent-code="categoryCode"
          :sub-category-code="subCategoryCode"
          class="caregory-filters"
        >
          <SelectSorting v-model="sort" class="filter" />
        </CategoryFilters>
      </Teleport>
    </ClientOnly>
    <GamesInfiniteList
      class="games-list"
      data-t="games-list"
      :request-params="findParams"
      :request-order-by="orderBy"
      :url="isFavorite ? '/casino/game/favorite/find' : '/casino/game/find'"
      @games-counter="handleZeroGamesFind"
      @all-games-forbidden="handleAllGamesForbidden"
    >
      <template #header>
        <div class="games-header">
          <div v-if="isMounted" class="title-wrapper">
            <h3 class="category-title">{{ categoryTitle }}</h3>
            <StCounter
              v-if="gamesCount"
              :live="false"
              bg-color="ghost"
              color="white"
              class="counter"
              :label="gamesCount"
            />
          </div>

          <StSkeletonLoader
            v-else
            bg-color="var(--background-primary)"
            height="28px"
            width="90px"
            :shimmer-opacity="0.25"
          />
          <div
            class="toggle-wrapper"
            :class="{ disabled: !allowedByCountryOnly }"
            data-t="allowed-by-country-toggle-5twf"
          >
            <span>
              {{ t('casino.showUnavailable') }}
              <span v-if="unavailableGamesCount">
                ({{ unavailableGamesCount }})
              </span>
            </span>
            <StToggle
              v-model="allowedByCountryOnly"
              :disabled="isAllGamesForbidden"
              class="toggle"
              size="s"
            />
          </div>
        </div>
      </template>
      <template #empty>
        <div class="empty-list" data-t="empty-list-6n8l">
          <StIcon name="filter-solid" :size="48" />
          <p>{{ t('casino.emptyList') }}</p>
        </div>
      </template>
    </GamesInfiniteList>
  </section>
</template>

<script setup lang="ts">
import CategoryFilters from './parts/CategoryFilters.vue'
import { useCategoryPage } from './useCategoryPage'

const { t } = useI18n()

const {
  findParams,
  categoryTheme,
  categoryCode,
  subCategoryCode,
  providerCode,
  categoryTitle,
  isAllGamesForbidden,
  orderBy,
  sort,
  allowedByCountryOnly,
  handleZeroGamesFind,
  handleAllGamesForbidden,
  unavailableGamesCount,
  gamesCount,
  isFavorite,
} = useCategoryPage()

const { isMounted } = useIsOnMounted()
</script>

<style scoped>
.category-page {
  display: flex;
  flex-direction: column;
}

.header {
  position: sticky;
  z-index: 10;
  top: 60px;

  display: flex;
  flex-direction: column;
  gap: var(--spacing-200);

  padding: var(--spacing-200) 0;

  background-color: var(--background-base);
}

.caregory-filters {
  margin-left: auto;
}

.games-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: var(--spacing-150);
}

.category-title {
  margin: 0;
  font: var(--desktop-text-lg-semibold);
}

.toggle {
  width: 36px;
}

.toggle-wrapper {
  display: flex;
  gap: var(--spacing-075);
  align-items: center;

  font: var(--desktop-text-xs-medium);
  color: var(--text-secondary);
}

.filters {
  display: flex;
  gap: var(--spacing-100);
  align-items: center;
}

.empty-list {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: var(--spacing-300);
  align-items: center;
  justify-content: center;

  padding: var(--spacing-600) var(--spacing-0);

  color: var(--text-tertiary);

  p {
    margin: 0;
    font: var(--desktop-text-md-medium);
    text-align: center;
  }
}

.title-wrapper {
  display: flex;
  gap: var(--spacing-075);
  align-items: center;
}
</style>
